<script lang="ts">
	import GradientBorder from '$lib/util/GradientBorder.svelte';
	import { walletAddress } from '$lib/wallet/store';
	import { optimism } from '@wagmi/core/chains';
	import { popupModalData, popupModalType } from '../popupsStore';
	import CopyToClipboard from 'svelte-copy-to-clipboard';
	import { getShortAddress } from '$lib/util/util';

	let COPY_ADDRESS_PERSONAL = '';
	function handleSuccessCopyPersonal() {
		COPY_ADDRESS_PERSONAL = 'Copied';
		setTimeout(() => {
			COPY_ADDRESS_PERSONAL = '';
		}, 2000);
	}

	let COPY_ADDRESS_SC = '';
	function handleSuccessCopySC() {
		COPY_ADDRESS_SC = 'Copied';
		setTimeout(() => {
			COPY_ADDRESS_SC = '';
		}, 2000);
	}

	function handleProceedToTnc() {
		popupModalData.set({});
		popupModalType.set('Tos');
	}
</script>

<GradientBorder
	gradient="bg-fx-gradient-6"
	paddingClass="p-px"
	borderRadius="rounded-2xl"
	outerClassList="w-fit h-fit max-w-[400px]"
	innerClassList="bg-fx-black"
>
	<div
		class="bg-fx-gradient-8-50 text-fx-white p-4 sm:p-8 rounded-2xl w-[95vw] sm:w-fit sm:min-w-[400px]"
	>
		<div class="text-fx-gradient-5 text-xl font-semibold">Smart Wallet Found</div>
		<div class="border-t border-t-fx-grey-800 w-full mb-6 mt-2" />
		<div>
			<div class="text-fx-grey-100 text-sm">
				You have been added to this smart wallet by someone else. Make sure it is someone you trust,
				as they have the authority to withdraw all assets from this wallet and possess all the
				permissions on your behalf.
			</div>

			<div class=" my-6 rounded-xl border border-fx-grey-600 p-6">
				<div class="flex justify-between">
					<div class="flex gap-2 justify-start">
						<div class="text-fx-grey-300 text-sm">Smart Wallet</div>
						<CopyToClipboard
							text={$popupModalData?.smartContractWalletAddress}
							on:copy={() => {
								handleSuccessCopySC();
							}}
							on:fail={() => {
								alert(
									'Failed to copy. Please copy manually ' +
										$popupModalData.smartContractWalletAddress
								);
							}}
							let:copy
						>
							<div
								class="text-fx-grey-400 flex items-center cursor-pointer text-xs gap-1.5"
								on:click={copy}
								on:keydown={copy}
							>
								<img src="scwallet/copy.png" class="w-4 h-4" alt="copy" />
								{COPY_ADDRESS_SC}
							</div>
						</CopyToClipboard>
					</div>
					<div class="text-sm text-fx-blue text-right flex gap-1.5">
						<div class="grow" />
						<div class="flex items-center cursor-pointer">
							{getShortAddress($popupModalData.smartContractWalletAddress)}
						</div>

						<a
							href="{optimism.blockExplorers?.default
								.url}/address/{$popupModalData.smartContractWalletAddress}"
							target="_blank"
							rel="noopener noreferrer"
							class="ml-auto my-auto"
						>
							<div class="flex items-center">
								<img src="external-link.svg" alt="help" class="w-5 h-5" />
							</div>
						</a>
					</div>
				</div>
				<div class="flex justify-between">
					<div class="flex gap-2">
						<div class="text-fx-grey-300 text-sm">Your Wallet</div>
						<CopyToClipboard
							text={$walletAddress}
							on:copy={() => {
								handleSuccessCopyPersonal();
							}}
							on:fail={() => {
								alert('Failed to copy. Please copy manually ' + $walletAddress);
							}}
							let:copy
						>
							<div
								class="flex items-center cursor-pointer text-fx-grey-400 text-xs gap-1.5"
								on:click={copy}
								on:keydown={copy}
							>
								<img src="scwallet/copy.png" class="w-4 h-4" alt="copy" />
								{COPY_ADDRESS_PERSONAL}
							</div>
						</CopyToClipboard>
					</div>
					<div class="text-sm text-fx-blue text-right flex gap-1.5">
						<div class="grow" />
						<div class="flex items-center cursor-pointer">
							{getShortAddress($walletAddress)}
						</div>
						<a
							href="{optimism.blockExplorers?.default.url}/address/{$walletAddress}"
							target="_blank"
							rel="noopener noreferrer"
							class="ml-auto my-auto"
						>
							<div class="flex items-center">
								<img src="external-link.svg" alt="help" class="w-5 h-5" />
							</div>
						</a>
					</div>
				</div>
			</div>

			<div
				class="mt-9 text-fx-black font-semibold text-center rounded-xl bg-fx-gradient-9 py-4 cursor-pointer hover:bg-opacity-70"
				on:click={() => {
					handleProceedToTnc();
				}}
				on:keydown={() => {
					handleProceedToTnc();
				}}
			>
				<span class="py-0.5">Proceed to TnC</span>
			</div>
		</div>
	</div>
</GradientBorder>
